import { useMemo, useState } from "react";
import { useDispatch } from "react-redux";
import { Button, ErrorMark, LineSeperator } from "../../../../../components/RegularComponents";
import PenaltiesDescriptionTable from "./PenaltiesDescriptionTable";
import PenaltiesDescriptionDetails from "./PenaltiesDescriptionDetails";
import { setInternalNoteList } from "../../../../../redux/slice/primaryAgencyApplicationSlice";
import { saveBusinessLicenceApplicationData } from "../../../../../redux/slice/businessLicenceApplicationSlice";
import { ADMINISTRATIVE_PENALTIES_NOTE_CATEGORY } from "../../InformationDetailPanel";
import { REQUEST_STATUS } from "../../../../../app/constants";
import { setCurrentAgentInternalNoteList } from "../../../../../redux/slice/additionalApplicationsSlice";
import { ERROR_STRING } from "../../../../../app/errors";

const AdministrativePenalties = (props) => {
  const [details, setDetails] = useState(null);

  return (
    <>
      {details ? (
        <PenaltiesDescriptionDetails details={details} setDetails={setDetails} />
      ) : (
        <>
          <AddPenaltiesDescription {...props} />
          <LineSeperator />
          <PenaltiesDescriptionTable {...props} setDetails={setDetails} />
        </>
      )}
    </>
  );
};

const AddPenaltiesDescription = ({
  appData,
  licenceApplication,
  applicationType,
  applicationMode,
  isAgencyApplication
}) => {
  const dispatch = useDispatch();
  const [descriptionText, setDescriptionText] = useState("");
  // const userEmail = licenceApplication?.userEmail;
  const [applicationSaveError, setApplicationSaveError] = useState(false);
  const [saveRequestProgress, setSaveRequestProgress] = useState(REQUEST_STATUS.IDLE);

  const internalNotes = useMemo(
    () => (appData.internalNoteList?.length > 0 ? appData.internalNoteList : []),
    [appData.internalNoteList]
  );

  const saveDescriptionText = (e) => {
    const description = descriptionText?.trim();
    if (!description) {
      return;
    }

    const newNote = {
      note: description,
      changeType: "SAVE",
      internalNoteCategory: ADMINISTRATIVE_PENALTIES_NOTE_CATEGORY
    };
    const newNotes = [...internalNotes, newNote];

    if (isAgencyApplication) {
      dispatch(setInternalNoteList(newNotes));
    } else {
      dispatch(setCurrentAgentInternalNoteList(newNotes));
    }

    setSaveRequestProgress(REQUEST_STATUS.IN_PROGRESS);
    setApplicationSaveError(false);

    dispatch(saveBusinessLicenceApplicationData(applicationType, applicationMode))
      .then((data) => {
        setSaveRequestProgress(REQUEST_STATUS.IDLE);
        setDescriptionText("");
      })
      .catch((err) => {
        // could not save the note. Show error
        setSaveRequestProgress(REQUEST_STATUS.ERROR);
        setApplicationSaveError(true);
        //Reset the messages for error
        if (isAgencyApplication) {
          dispatch(setInternalNoteList(internalNotes));
        } else {
          dispatch(setCurrentAgentInternalNoteList(internalNotes));
        }
      });
  };

  return (
    <div>
      <div style={{ color: "#555", padding: "5px 0px", fontWeight: "bold" }}>
        {"Administrative Penalties and Licence Conditions Description"}
      </div>
      <div className="textarea fw-35 bottomMarginNormal">
        <textarea
          className="ns-input"
          rows={5}
          cols={80}
          value={descriptionText ?? ""}
          maxLength={5000}
          disabled={licenceApplication?.originalApplicationId} //Disabled for Archived licence
          onInput={(e) => {
            setDescriptionText(e.target.value);
          }}
        />
      </div>
      <div className="row bottomMarginMedium">
        <div className={"col-lg-4" + (applicationSaveError ? " has-error" : "")}>
          <Button
            id="save-internal-note"
            disabled={!descriptionText || licenceApplication?.originalApplicationId}
            className="btn btn-success"
            text={"Save "}
            onClick={saveDescriptionText}
            showProgress={saveRequestProgress === REQUEST_STATUS.IN_PROGRESS}
          />
          {applicationSaveError && ErrorMark()}
          {applicationSaveError && (
            <div className="ns-error-message help-block topMarginNormal">
              <span className="ns-visually-hidden">Error:</span>
              {ERROR_STRING.APPLICATION_SAVE_ERROR}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AdministrativePenalties;
